import { request, RespError, handleFormatRes } from '../../utils';
import { CHECK_ACT_UINRULE, SEGMENT_REPORT } from '../../config/url';
/** 需要转成 int 型的 key 数组 */
const needParseBoolKey = ['isExpired', 'isBlock'];
// 需要转成 date 型的 key 数组
const needParseDateKey = ['sysTime'];
/**
 * 查询用户是否可参与活动
 */
export async function checkActUinRule({ checkActList }) {
    try {
        // 参数格式化
        const params = {
            t: new Date().getTime(),
            act_listid_list: JSON.stringify(checkActList.map(({ actListid }) => ({
                act_listid: actListid,
            }))),
        };
        // 接口请求
        const result = await request.get(`${CHECK_ACT_UINRULE}?${SEGMENT_REPORT}`, { params });
        if (result) {
            // 正常的返回
            if ((result === null || result === void 0 ? void 0 : result.retcode) === '0') {
                const res = handleFormatRes({
                    result,
                    needParseBoolKey,
                    needParseDateKey,
                    // 由于本接口是checkUseract的翻版，因此，为了保持数据格式一致，下面保持和checkUseract一致的结构，这样可以直接替换之前的函数
                    transformer: (res) => ({
                        userActInfoList: res.userinfoList.map((item) => {
                            const { actListid, isBlock, isExpired } = item;
                            const isValid = !isBlock;
                            return {
                                actListid,
                                isExpired,
                                isValid,
                            };
                        }),
                    }),
                });
                return res;
            }
            // 状态码错误的返回
            throw new RespError(result.retcode, result.retmsg, result);
        }
        throw result;
    }
    catch (error) {
        throw error;
    }
}
